import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // if (req.method == 'GET') {
  //   let params = req.params;
  //   const workID =  params.get('workid');
  //   if(workID == null || workID == 'null'){
  //     params = params.set('workid',"")
  //   }
  //   const authReq = req.clone({ params });
  //   return next(authReq);
  // }else {
  //   const req_body: any = req.body;
  //   if (req.body instanceof ArrayBuffer) {
  //     return next(req);
  //   } else {
  //     const workID = req_body['workid'];
  //     if(workID == null || workID == 'null'){
  //       req_body['workid'] = "";
  //     }
  //     const updatedBody = {
  //       ...req_body
  //     };
  //     const authReq = req.clone({ body: updatedBody });
  //     return next(authReq);
  //   }
  // }
  return next(req)
};
